"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEACTIVATE_DEVICE_QUERY = "\n  mutation DeactivateDevice($deviceId: ID!) {\n  deactivateDevice(deviceId: $deviceId) {\n        __typename\n        ... on GenericDeviceResponse {\n           message\n        }\n        ... on DeviceDeactivationLimitExceeded {\n         maxDeviceLimit\n        }\n  }\n}";
exports.default = DEACTIVATE_DEVICE_QUERY;
//# sourceMappingURL=deactivateDevice.js.map